// Words of the site builder (stage J2): a block's summary in the list of the page — «Доклады · Категория = Архитектура · по Начало ·
// 12» for a «Запрос» — and what is wrong with a page address, the same words the server says.

import { pagePathProblem, type MetaIndex, type PageBlock } from '@confdeck/core-shared';

const str = (v: unknown) => (v == null ? '' : String(v).trim());

/** The parameters of a block in a few words; a «Запрос» tells its section, conditions, order and count. */
export function blockSummary(meta: MetaIndex, b: PageBlock): string {
  const p = b.params ?? {};
  if (b.key === 'query') {
    const type = meta.types().find((t) => t.id === p.type || t.key === p.type);
    const name = (key: string) => (type ? meta.field(type.id, key)?.name ?? key : key);
    const conds = str(p.where).split('\n').map((l) => l.trim()).filter(Boolean);
    if (str(p.filter_field) && str(p.filter_value)) conds.unshift(`${name(str(p.filter_field))} = ${str(p.filter_value)}`);
    const parts = [type?.nameMany ?? 'Раздел не выбран', ...conds, str(p.sort) ? `по ${name(str(p.sort))}${p.dir === 'desc' ? ' ↓' : ''}` : '', str(p.count) || '24'];
    return parts.filter(Boolean).join(' · ');
  }
  return str(p.heading || p.label || p.section);
}

/** A page address the server will refuse, in its words; null — fine. */
export const pathProblem = (path: string): string | null => pagePathProblem(path);
